import styled from 'styled-components';
import {COLOR_CI_BLUE} from '../../../config';

export const ContentInfoBoxContainer = styled.div`
    display: flex;
    position: relative;
`;

export const ContentInfoBoxIcon = styled.div`
    flex: 0 0 4.5rem;
    margin-right: 2.5rem;
`;

export const ContentInfoBoxHeadline = styled.h4`
    color: ${COLOR_CI_BLUE};
    font-weight: 400;
    font-size: 1.5rem;
    line-height: 1;
    margin-bottom: .7em;
`;

export const ContentInfoBoxListContainer = styled.ul`
    margin: 0;
    padding: 0;
`;
